var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectIvIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ConnectIv_Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 227.1 49.2",
    style: {
      enableBackground: "new 0 0 227.1 49.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.connect-iv-st0{fill:#512F8B;}\r\n\t.connect-iv-st1{fill:#411E75;}\r\n\t.connect-iv-st2{fill:#310557;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st0",
    d: "M44.3,32.6c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c-0.1-0.9-0.4-1.8-0.9-2.6l-0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.3 L32.6,10.7c-0.2,0.6-0.5,1.2-0.8,1.8l-7.5,13l6.5,11.1c1.2,2.1,3.4,3.4,5.6,3.6H37c3.5,0,6.5-2.5,7.2-5.8c0,0,0,0,0,0 c0-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C44.3,32.8,44.3,32.7,44.3,32.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st1",
    d: "M15.9,10.9l6.3,10.9l6.3-10.9c1.9-3.2,0.9-7.4-2-9.5c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.3-0.2-0.4-0.3 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.3-0.1-0.5-0.2 c0,0-0.1,0-0.1,0c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.1-0.5,0.1c-0.1,0-0.1,0-0.1,0 c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0-0.1,0-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.1C18.7,0.9,18.6,1,18.5,1 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0-0.1,0.1-0.2,0.1C14.9,3.6,14,7.7,15.9,10.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st2",
    d: "M0,32.6c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c0.1-0.9,0.4-1.8,0.9-2.6l0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3 l10.4-18.1c0.2,0.6,0.5,1.2,0.8,1.8l7.5,13l-6.5,11.1c-1.2,2.1-3.4,3.4-5.6,3.6H7.3c-3.5,0-6.5-2.5-7.2-5.8c0,0,0,0,0,0 c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C0,32.8,0,32.7,0,32.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st2",
    d: "M64.6,10.6c4.9,0,8.6,2.8,9.8,7.2h-5.5c-0.8-1.8-2.4-2.6-4.3-2.6c-3.1,0-5.2,2.3-5.2,5.9 c0,3.6,2.1,5.9,5.2,5.9c1.9,0,3.5-0.9,4.3-2.6h5.5c-1.2,4.5-4.9,7.2-9.8,7.2c-6.1,0-10.3-4.3-10.3-10.5 C54.3,15,58.6,10.6,64.6,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st2",
    d: "M87.2,31.7c-5.8,0-10.6-4.4-10.6-10.6c0-6.2,4.7-10.5,10.6-10.5c5.9,0,10.5,4.3,10.5,10.5 C97.7,27.3,93,31.7,87.2,31.7z M87.2,27.1c3.3,0,5.4-2.4,5.4-6c0-3.7-2.1-6-5.4-6c-3.3,0-5.5,2.3-5.5,6 C81.7,24.7,83.9,27.1,87.2,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st2",
    d: "M118.9,10.9v20.6h-5l-8.4-12.7v12.7h-5V10.9h5l8.4,12.8V10.9H118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st2",
    d: "M141,10.9v20.6h-5l-8.4-12.7v12.7h-5V10.9h5l8.4,12.8V10.9H141z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st2",
    d: "M157.2,14.9h-7.6v4.2h6.7v3.9h-6.7v4.5h7.6v4h-12.6V10.9h12.6V14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st2",
    d: "M169.9,10.6c4.9,0,8.6,2.8,9.8,7.2h-5.5c-0.8-1.8-2.4-2.6-4.3-2.6c-3.1,0-5.2,2.3-5.2,5.9 c0,3.6,2.1,5.9,5.2,5.9c1.9,0,3.5-0.9,4.3-2.6h5.5c-1.2,4.5-4.9,7.2-9.8,7.2c-6.1,0-10.3-4.3-10.3-10.5 C159.6,15,163.9,10.6,169.9,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st2",
    d: "M181.7,10.9h15.9v4h-5.5v16.6h-5V14.9h-5.5V10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st2",
    d: "M200.1,10.9h5v20.6h-5V10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "connect-iv-st2",
    d: "M222.8,10.9h5.3l-7.3,20.6h-6.3l-7.3-20.6h5.3l5.1,15.5L222.8,10.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIvIcon);
export default __webpack_public_path__ + "static/media/ConnectIvIcon.95e4f50d.svg";
export { ForwardRef as ReactComponent };